import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/fund_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Fund',
    column_type: 'string',
    column_name: 'name',
  },
  short_name_cont: {
    model_name: 'Fund',
    column_type: 'string',
    column_name: 'shortName',
  },
  code_cont: {
    model_name: 'Fund',
    column_type: 'string',
    column_name: 'code',
  },
  setup_date_gteq: {
    column_type: 'date',
    model_name: 'Fund',
    column_name: 'setupDate',
  },
  setup_date_lteq: {
    column_type: 'date',
    model_name: 'Fund',
    column_name: 'setupDate',
  },
  custodian_cont: {
    model_name: 'Fund',
    column_type: 'string',
    column_name: 'custodian',
  },
  risk_level_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Fund',
      options: ['R1', 'R2', 'R3', 'R4', 'R5'],
    },
    model_name: 'Fund',
    column_name: 'riskLevel',
  },
  visibility_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Fund',
      options: ['holder', 'holder_and_visitor', 'invisible'],
    },
    model_name: 'Fund',
    column_name: 'visibility',
  },
  visibility_not_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Fund',
      options: ['holder', 'holder_and_visitor', 'invisible'],
    },
    model_name: 'Fund',
    column_name: 'visibility',
  },
  is_index_eq: {
    column_type: 'boolean',
    model_name: 'Fund',
    column_name: 'isIndex',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'short_name': { required: true, disabledUpdate: false },
    'code': { required: true, disabledUpdate: false },
    'setup_date': { required: true, disabledUpdate: false },
    'custodian': { required: true, disabledUpdate: false },
    'early_warning': { required: true, disabledUpdate: false },
    'risk_level': { required: false, disabledUpdate: false },
    'closed_period': { required: true, disabledUpdate: false },
    'visibility': { required: false, disabledUpdate: false },
    'allot_process': { required: true, disabledUpdate: false },
    'total_scale': { required: true, disabledUpdate: false },
    'allot_trade_rule_id': { required: false, disabledUpdate: false },
    'redeem_trade_rule_id': { required: false, disabledUpdate: false },
    'fee_rate': { required: true, disabledUpdate: false },
    'management': { required: true, disabledUpdate: false },
  },
  'fee_rate': {
    'id': { required: false, disabledUpdate: true },
    'allot_fee': { required: true, disabledUpdate: true },
    'redeem_fee': { required: true, disabledUpdate: true },
    'management_fee': { required: true, disabledUpdate: true },
    'custodian_fee': { required: true, disabledUpdate: true },
    'outsourcing_service_fee': { required: true, disabledUpdate: true },
    'achievement_pay': { required: true, disabledUpdate: true },
    'accrual_time': { required: true, disabledUpdate: true },
  },
  'management': {
    'id': { required: false, disabledUpdate: true },
    'open_day': { required: true, disabledUpdate: true },
    'allot_day': { required: true, disabledUpdate: true },
    'redeem_day': { required: true, disabledUpdate: true },
    'transaction_process': { required: true, disabledUpdate: true },
    'allot_threshold': { required: true, disabledUpdate: true },
    'redeem_limit': { required: true, disabledUpdate: true },
    'raise_account': { required: true, disabledUpdate: true },
    'investment_scope': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Fund', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Fund', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
